import React, { useEffect } from 'react';
import { T, M, A } from 'TOMA';
import styles from './events.module.scss';
import ThumbnailEvent from '../../../components/ThumbnailEvent/ThumbnailEvent';
import { EventRepository } from '../../../services/Event/Event.repository';
import BreadCrumb from '../../../components/BreadCrumb/BreadCrumb';

export default function Events(): JSX.Element {
  const [events, setEvents] = React.useState<any[]>([]);
  const [isRefreshing, setIsRefreshing] = React.useState<boolean>(false);

  const eventRepository = new EventRepository();

  useEffect(() => {
    eventRepository.getPublicEvents().then((data) => {
      const formattedData = data.map((event) => ({
        ...event,
        image:
          event.logo_uuid && process.env.REACT_APP_API_URL
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${event.logo_uuid}.${event.logo_extension}`
            : null,
        year: event.year || null,
      }));
      setEvents(formattedData);
    });
  }, []);

  return (
    <div className={styles.ExhibitorList}>
      <BreadCrumb
        breadCrumb={[
          {
            icon: null,
            href: undefined,
            label: 'Events',
            isCurrent: true,
          },
        ]}
      />
      <h1 className={styles.ExhibitorList__title}>List of Events</h1>
      <M.Loading loading={isRefreshing} overlay>
        {events.length === 0 && (
          <div className={styles.ExhibitorList__nofound}>No event found...</div>
        )}
        <ul className={styles.ExhibitorList__List}>
          {events.map(({ id, name, slug, subtitle, image, year }) => (
            <li className={styles.ExhibitorList__List__li} key={id}>
              <ThumbnailEvent
                id={id}
                slug={slug}
                name={name}
                year={year}
                subtitle={subtitle}
                image={image}
                showroom={true}
              />
            </li>
          ))}
        </ul>
      </M.Loading>
    </div>
  );
}
